import React from 'react';

export const Label = ({ children }: LabelProps): React.JSX.Element => {
    return (
        <label className="label">
            <span className="label-text">{children}</span>
        </label>
    );
};

interface LabelProps {
    children: React.ReactNode;
}

export default Label;
